import React, { useState } from "react";
import api from "../../../../features/auth/axiosConfig";
import { ProfileData } from "../types/profile";
import UserProfileForm from "./UserProfileForm";
import { useUserProfileForm } from "../hooks/useUserProfileForm";
import CommonButtons from "../../../components/CommonButtons";
import { ModalWrapper } from "../../../../shared/components/ModalWrapper";
import { notifyError, notifySuccess } from "src/assets/toastService";

interface EditUserProfileProps {
  profileData: ProfileData | null;
  onClose: () => void;
  onSave: () => void;
}

const EditUserProfile: React.FC<EditUserProfileProps> = ({ profileData, onClose, onSave }) => {
  const { formData, handleChange } = useUserProfileForm(profileData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!profileData) return;

    setLoading(true);
    try {
      await api.put(`/pos/profile/${profileData._id.$oid}`, formData);
      notifySuccess("Profile updated successfully!");
       setTimeout(() => {
      onSave();
      onClose();
    }, 1000);
    } catch (error) {
      console.error("Error updating profile:", error);
      notifyError("Failed to update profile. Please try again.");
      setLoading(false);
    }
  };

  if (!profileData) return null;

  return (
    <ModalWrapper title="Edit User Profile" useTheme={true} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <UserProfileForm formData={formData} handleChange={handleChange} />
        <div className="flex justify-end gap-6 pt-4">
          <CommonButtons className="w-36" label="CANCEL" variant="outlineDanger" onClick={onClose} />
          <CommonButtons className="w-36" label={loading ? "Saving..." : "Confirm"} type="submit" disabled={loading} />
        </div>
      </form>
    </ModalWrapper>
  );
};

export default EditUserProfile;
